import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  forwardRef,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() formGroup: FormGroup;
  @Input() formControlName = '';
  @Input() label = '';
  @Input() type = 'text';
  originalType = 'text';
  @Input() widthLimited = false;
  @Input() disabled = false;
  isRequired = false;
  showHide = '../../../../assets/hide.svg';

  value: string;

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  ngOnInit() {
    this.originalType = this.type + '';
    this.updateRequiredValidator();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup'] || changes['formControlName']) {
      this.updateRequiredValidator();
    }
  }

  private updateRequiredValidator() {
    this.isRequired = this.hasRequiredValidator(this.formControlName);
  }

  private hasRequiredValidator(controlName: string): boolean {
    const control: AbstractControl = this.formGroup.get(controlName);
    if (control && control.validator) {
      const validators = control.validator({} as AbstractControl);
      return validators && validators['required'] !== undefined;
    }
    return false;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value); // Notify the form about the change
    this.onTouched(); // Mark as touched
  }

  showHideField() {
    if (this.type === 'password') {
      this.type = 'text';
      this.showHide = '../../../../assets/show.svg';
    } else {
      this.type = 'password';
      this.showHide = '../../../../assets/hide.svg';
    }
  }
}
